import React from "react";
import {
  UnifiedContainer,
  Breadcrumb,
  ChatContainerMobile,
  ChatWrapper,
  WidgetChatWrapperMobile,
  CustomGenericListStyleMobile,
  WidgetContainerMobile,
} from "../BaseUnifiedProfilePage.styled";
import BaseUnifiedProfilePage from "../BaseUnifiedProfilePage";
import Assistance  from "../components/Assistance/Assistance";
import GeneralInfo from "../components/Cards/GeneralInfo";
import GarageCard from "../components/Cards/GarageCard";
import Appointments from "../components/Cards/Appointments";
import Notification from "../components/Cards/Notification";
import RepairOrders from "../components/Cards/RepairOrders";
import Notes from "../components/Cards/Notes";
import DealershipTeam from "../components/Cards/DealershipTeam";
import { observer } from "mobx-react";
import { useUserCheckPermissions } from "../../../../hooks/useUserCheckPermissions";
import { PermissionCodes, PermissionLevels } from "../../../../utils/enums";

const UnifiedProfilePageMobile = observer(() => {
  const { checkPermission } = useUserCheckPermissions();

  return (
    <BaseUnifiedProfilePage>
      <UnifiedContainer>
        <Breadcrumb>Contacts</Breadcrumb>
        <WidgetChatWrapperMobile>
          <WidgetContainerMobile>
            {checkPermission(PermissionCodes.UCP_CONTACT_INFO, PermissionLevels.VIEW) && <GeneralInfo />}
            {checkPermission(PermissionCodes.UCP_TEAM, PermissionLevels.VIEW) && <DealershipTeam />}
            {checkPermission(PermissionCodes.UCP_GARAGE, PermissionLevels.VIEW) && <GarageCard />}
            {checkPermission(PermissionCodes.UCP_APPOINTMENTS, PermissionLevels.VIEW) && <Appointments />}
            {checkPermission(PermissionCodes.UCP_REPAIR_ORDERS, PermissionLevels.VIEW) && <RepairOrders />}
            {(checkPermission(PermissionCodes.UCP_NOTIFICATIONS, PermissionLevels.VIEW) || checkPermission(PermissionCodes.UCP_NOTIFICATIONS, PermissionLevels.UPDATE)) && <Notification />}
            {checkPermission(PermissionCodes.UCP_NOTES, PermissionLevels.VIEW) && <Notes/>}
            <ChatContainerMobile >
              <ChatWrapper>
                <Assistance />
              </ChatWrapper>
            </ChatContainerMobile>
          </WidgetContainerMobile>
        </WidgetChatWrapperMobile>
        <CustomGenericListStyleMobile />
      </UnifiedContainer>
    </BaseUnifiedProfilePage>
  );
});

export default UnifiedProfilePageMobile;
